<template>
  <div class="min-h-screen flex flex-col bg-gray-50 text-gray-800">
    <AppHeader />

    <main class="flex-1 container mx-auto px-4 py-6">
      <router-view />
    </main>

    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
</script>
